import script from "./NewForgotPasswordView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewForgotPasswordView.vue?vue&type=script&setup=true&lang=ts"

import "./NewForgotPasswordView.vue?vue&type=style&index=0&id=251baab4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251baab4"]])

export default __exports__